// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3N3be","left":"StickyBox_left__ZEY4X","right":"StickyBox_right__XrMch"};